import useOfferingModel from "./useOfferingModel";

export { default as apiOfferingModel } from "./apiOfferingModel";
export default useOfferingModel;
